import { State } from 'redux/types';
import { SocialState } from './types';

export const stateSelector = (state: State): SocialState => state.get('social');
